"use strict";

var _ = require("../utils/mindash");
var ActionHandlerNotFoundError = require("../errors/actionHandlerNotFound");
var ActionPredicateUndefinedError = require("../errors/actionPredicateUndefined");

function validateHandlers(store) {
  _.each(store.handlers, function (actionPredicate, handlerName) {
    var actionHandler = store[handlerName];

    if (_.isUndefined(actionHandler) || _.isNull(actionHandler)) {
      throw new ActionHandlerNotFoundError(handlerName, store);
    }

    if (!actionPredicate) {
      throw new ActionPredicateUndefinedError(handlerName, store);
    }
  });
}

module.exports = validateHandlers;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/store/validateHandlers.js
 ** module id = 481
 ** module chunks = 0
 **/